import Reveal from "@/components/site/Reveal";
import PartnerApplicationForm from "@/components/site/PartnerApplicationForm";
import { openCalendly } from "@/lib/constants";

export default function ApplySection() {
  return (
    <section
      id="apply"
      className="section-pad"
      style={{ background: "var(--color-bg-soft)" }}
    >
      <div className="container-wide grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16">
        <Reveal className="lg:col-span-2">
          <div className="eyebrow mb-5">Apply now</div>
          <h2 className="type-section-heading mb-5">
            Ready to take the next step?
          </h2>
          <p className="type-body-large mb-6">
            Apply to join the SmartEdge team. We&apos;ll review your
            application and schedule an onboarding call within 2 business days.
          </p>
          <div className="flex flex-col gap-3 mt-4">
            <div
              className="type-caption"
              style={{ color: "var(--color-label)", fontWeight: 500 }}
            >
              Prefer to talk first?
            </div>
            <button
              type="button"
              className="btn-ghost"
              onClick={openCalendly}
              style={{ alignSelf: "flex-start" }}
            >
              Schedule a call with Dan →
            </button>
          </div>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-3">
          <PartnerApplicationForm />
        </Reveal>
      </div>
    </section>
  );
}
